import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
/* Preconnect to Google Fonts to reduce DNS + TCP latency */
const preconnect1 = document.createElement('link');
preconnect1.rel = 'preconnect';
preconnect1.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnect1);
const preconnect2 = document.createElement('link');
preconnect2.rel = 'preconnect';
preconnect2.href = 'https://fonts.gstatic.com';
preconnect2.crossOrigin = 'anonymous';
document.head.appendChild(preconnect2);
/* Utmify Pixel */
window.pixelId = '69a73b2c749560c8951e8be3';
const utmifyScript = document.createElement('script');
utmifyScript.setAttribute('async', '');
utmifyScript.setAttribute('defer', '');
utmifyScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
document.head.appendChild(utmifyScript);
render(<App data-id="element-493" />, document.getElementById('root'));